<!-- type=pacman -->
<!--<ngx-spinner bdColor="rgba(0, 0, 0, 0.75)" size="large"-->
<!--             color="#fff" type="square-jelly-box"-->
<!--             [fullScreen]="true">-->
<!--   <p style="color: white; margin-top: 90px; font-weight: bold">Caricamento...</p>-->
<!--</ngx-spinner>-->

<ngx-spinner bdColor="rgba(0, 0, 0, 0.2)" size="large" color="#0F62FE" type="ball-clip-rotate" [fullScreen]="true"></ngx-spinner>

<!--<app-dialog></app-dialog>-->

<router-outlet></router-outlet>
